export default {
  // 快捷键
  // 支持快捷键 例如 ctrl+shift+s
  hotkey: {
    search: {
      open: 's',
      close: 'esc'
    }
  },
  // 侧边栏默认折叠状态
  menu: {
    asideCollapse: false,
    projectCollapse: false,
    userCollapse: false
  },
  // 在读取持久化数据失败时默认页面
  page: {
    opened: [
      {
        name: 'index',
        fullPath: '/',
        meta: {
          title: '首页',
          auth: false
        }
      }
    ]
  },
  // 菜单搜索
  search: {
    enable: true
  },
  // 注册的主题
  theme: {
    list: [
      {
        title: '蓝色',
        name: 'd2',
        preview: 'image/theme/d2/preview@2x.png'
      },
      {
        title: '紫色',
        name: 'violet',
        preview: 'image/theme/violet/preview@2x.png'
      },
      {
        title: '黑色',
        name: 'line',
        preview: 'image/theme/line/preview@2x.png'
      },
      {
        title: '绿色',
        name: 'green',
        preview: 'image/theme/green/preview@2x.png'
      },
      {
        title: '红色',
        name: 'red',
        preview: 'image/theme/red/preview@2x.png'
      },
      {
        title: '橙色',
        name: 'orange',
        preview: 'image/theme/orange/preview@2x.png'
      }
    ]
  },
  // 是否默认开启页面切换动画
  transition: {
    active: true
  }
}
